import React, { useContext } from 'react'
import JunctionStatusList from './junstionStatus'
import { MapsContext } from '../../maps/context/context'
import { Title } from '../../../../../stories/Title/Title';

import SignalsTable from '../vendorwise/SignalsTable';
import { VendorListPageFor } from '../vendorwise/List';

const JunctionDetails = () => {

  const {state}=useContext(MapsContext);
  return (
    <div className='junc-detail-report'>
        <div className="junc-detail-report__title">
          <Title variant='subtitle1'><b>{state.junctionType}</b></Title>
        </div>
        <div className="junc-detail-report__block row g-0">
            <div className="junc-detail-report__block--left col-2">
                <JunctionStatusList/>
            </div>
            <div className="junc-detail-report__block--right col">
           <SignalsTable pageType={VendorListPageFor.VENDOR_WISE} />

            </div>
        </div>
      
    </div>
  )
}

export default JunctionDetails
